var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSessionRecording(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 39,
    height: 28,
    viewBox: "0 0 39 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Artboard_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 39,
    height: 28
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Artboard_2",
    "data-name": "Artboard \\u2013 2",
    clipPath: "url(#clip-Artboard_2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_194",
    "data-name": "Union 194",
    d: "M5530.785-4895.143a2.787,2.787,0,0,1-2.786-2.786v-22.286a2.786,2.786,0,0,1,2.786-2.786h23.679a2.786,2.786,0,0,1,2.786,2.786v5.656l7.55-5.392a1.393,1.393,0,0,1,1.443-.1,1.4,1.4,0,0,1,.757,1.234v19.5a1.4,1.4,0,0,1-.757,1.234,1.393,1.393,0,0,1-1.443-.1l-7.55-5.39v5.654a2.786,2.786,0,0,1-2.786,2.786Zm0-2.786h23.679v-8.357a1.394,1.394,0,0,1,.757-1.232,1.393,1.393,0,0,1,1.443.1l7.55,5.39v-14.1l-7.55,5.39a1.392,1.392,0,0,1-1.443.1,1.394,1.394,0,0,1-.757-1.232v-8.358h-23.679Zm4.715-16.643a1.5,1.5,0,0,1-1.5-1.5,1.5,1.5,0,0,1,1.5-1.5h14a1.5,1.5,0,0,1,1.5,1.5,1.5,1.5,0,0,1-1.5,1.5Z",
    transform: "translate(-5528 4923)",
    fill: "#6b6b6b"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSessionRecording);
export default __webpack_public_path__ + "static/media/sessionRecording.2cbfe3090acc319097e2d72fb37f7fc7.svg";
export { ForwardRef as ReactComponent };